/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Injectable} from '@angular/core';
import {Service} from '../../common/service.class';
import {LifeCertification} from './life-certification.model';
import {UserIdentifiedModelListService} from '../../common/user-identified-model-list.service';

@Injectable()
export class LifeCertificationService extends UserIdentifiedModelListService<LifeCertification> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'lifeCertification', LifeCertification);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/lifecertification/life-certification.service.ts